import { Navigate, Outlet, useOutletContext } from "react-router";
import type { AppOutletContext } from "@/src/layouts/AppLayout";
import {
  NAV_ACCESS,
  isAccountTypeAllowed,
  resolveFallbackPath,
  type NavAccessKey,
} from "@/src/lib/nav-access";

export default function RequireAccountType({ navKey }: { navKey: NavAccessKey }) {
  const ctx = useOutletContext<AppOutletContext | null>();
  const rule = NAV_ACCESS[navKey];
  if (ctx && !isAccountTypeAllowed(ctx.apiUser?.accountType, rule)) {
    return (
      <Navigate
        to={resolveFallbackPath(ctx.apiUser?.accountType, ctx.enableMonitoring, ctx.hasActivePlan)}
        replace
      />
    );
  }
  return <Outlet context={ctx} />;
}
